export const RELATIONSHIP_TAGS = [
  { value: "Wife/Partner", label: "Wife / Partner" },
  { value: "Kids/Daughter/Son", label: "Kids / Daughter / Son" },
  { value: "Mom/In-Laws", label: "Mom / In-Laws" },
  { value: "Crush/Dating", label: "Crush / Dating" },
  { value: "Friends", label: "Friends" },
  { value: "Special/Confidential", label: "Special / Confidential" },
  { value: "Client/Work", label: "Client / Work" },
] as const;


export type RelationshipTag = (typeof RELATIONSHIP_TAGS)[number]["value"];

export const AGE_GROUPS = [
  { value: "adult", label: "Adult" },
  { value: "teen", label: "Teen" },
  { value: "kid", label: "Kid (0-12)" },
] as const;

export const INTEREST_TAGS = [
  { value: "florals", label: "Florals" },
  { value: "spa", label: "Spa & Self-Care" },
  { value: "jewelry", label: "Jewelry" },
  { value: "gourmet", label: "Gourmet & Sweets" },
  { value: "toys", label: "Toys & Play" },
  { value: "books", label: "Books" },
  { value: "tech", label: "Tech & Gadgets" },
  { value: "fashion", label: "Fashion" },
  { value: "wellness", label: "Wellness & Fitness" },
  { value: "home", label: "Home & Candles" },
] as const;

export const DROP_VIBES = [
  { value: "classic", label: "Classic", hint: "Timeless, elegant, never risky." },
  { value: "modern", label: "Modern", hint: "Architectural, minimal, sculptural." },
  { value: "bright", label: "Playful & Bright", hint: "Colorful, joyful, high energy." },
  { value: "dealers_choice", label: "Dealer's Choice", hint: "Let our curators decide." },
] as const;

/** Dispatch lanes the platform can actually execute today. */
export const GIFT_LANES = [
  { value: "florals", label: "Florals" },
  { value: "curated_gift", label: "Curated gift" },
  { value: "local_coffee", label: "Local coffee" },
  { value: "local_lunch", label: "Local lunch" },
  { value: "egift", label: "Instant e-gift" },
] as const;

/** Reminder thresholds (days before the milestone). 14/7/3 are on by default. */
export const REMINDER_THRESHOLDS = [
  { value: 14, label: "2 weeks" },
  { value: 7, label: "7 days" },
  { value: 3, label: "3 days" },
  { value: 1, label: "Day before" },
] as const;

export const DEFAULT_REMINDER_SET = [14, 7, 3];

/** Milestone rows we pre-suggest when a relationship tag is picked. */
export const SUGGESTED_DATE_TYPES: Record<string, string[]> = {
  "Wife/Partner": ["birthday", "anniversary"],
  "Crush/Dating": ["birthday"],
  "Kids/Daughter/Son": ["birthday"],
  "Mom/In-Laws": ["birthday"],
  Friends: ["birthday"],
  "Special/Confidential": ["birthday"],
  "Client/Work": ["birthday", "work_anniversary"],
};

export const INACTIVITY_NUDGE_OPTIONS = [
  { value: 0, label: "Off" },
  { value: 30, label: "30 days" },
  { value: 60, label: "60 days" },
  { value: 90, label: "90 days" },
] as const;
